const GET_URL = "https://getinverters-v3vjxtfmlq-uc.a.run.app";
const CHECK_URL = "https://checkinverter-v3vjxtfmlq-uc.a.run.app";

let inverterList = [];

// Fetch inverter list on page load
async function loadInverters() {
  try {
    const res = await fetch(GET_URL);
    inverterList = await res.json();
    const datalist = document.getElementById("inverterOptions");
    if (!datalist) return; // Exit early if the widget isn't present
    
    datalist.innerHTML = inverterList.map(inv =>
      `<option value="${inv['Inverter Name']}">`).join("");
  } catch (err) {
    console.error("Failed to load inverters:", err);
  }
}

// Check inverter compatibility
async function checkInverter() {
  const btn = document.getElementById("checkBtn");
  const name = document.getElementById("inverterInput").value.trim();
  const result = document.getElementById("result");
  if (!name) {
    result.innerHTML = "<span style='color:red;'>Please enter an inverter name.</span>";
    return;
  }

  btn.disabled = true;
  btn.textContent = "Checking...";
  btn.style.background = "#555";

  try {
    const res = await fetch(CHECK_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ inverterName: name })
    });
    const data = await res.json();

    if (data.Status && data.Status.includes("✅")) {
      result.innerHTML = `<strong style='color:green;'>✅ Compatible</strong><br><small>${data.Notes || ""}</small>`;
    } else if (data.Status && data.Status.includes("❌")) {
      result.innerHTML = `<strong style='color:red;'>❌ Not Compatible</strong><br><small>${data.Notes || ""}</small>`;
    } else {
      result.innerHTML = `<strong style='color:orange;'>❓ Unknown</strong><br><small>We've added "${name}" to our list for review.</small>`;
    }
  } catch (err) {
    console.error("Error checking inverter:", err);
    result.innerHTML = "<span style='color:red;'>Error checking inverter. Please try again later.</span>";
  } finally {
    setTimeout(() => {
      btn.disabled = false;
      btn.textContent = "Check Compatibility";
      btn.style.background = "#0073e6";
    }, 2000);
  }
}

// Load inverter list when widget loads
document.addEventListener("DOMContentLoaded", loadInverters);
